var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      staticStyle: { width: "100%", "margin-top": "10px" },
      attrs: { border: "", data: _vm.operatingRecord },
    },
    [
      _c("el-table-column", {
        attrs: { label: "操作名称", align: "center", prop: _vm.operationName },
      }),
      _c("el-table-column", {
        attrs: { label: "操作人", align: "center", prop: _vm.operatorName },
      }),
      _c("el-table-column", {
        attrs: { label: "时间", align: "center", prop: _vm.operationTime },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("formatDate")(
                        scope.row.operationTime ? scope.row.operationTime : ""
                      )
                    )
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }